module.exports = __webpack_public_path__ + "img/DerAufprall7.4a746509.jpg";